import { TabModule } from '../../../utils/constants/commonConstants';

export const MOBILE_SECTION_IDS = [TabModule.OVERVIEW, TabModule.MANAGEMENT_PROFILE, TabModule.AUDITED_FINANCIALS] as const;

export const isMobileSectionId = (id: string): id is (typeof MOBILE_SECTION_IDS)[number] =>
    (MOBILE_SECTION_IDS as readonly string[]).includes(id);
